const stats = [
  { value: "60+", label: "收录作品" },
  { value: "4", label: "主题单元" },
  { value: "每周", label: "片单更新" },
];

export default function Hero() {
  return (
    <section id="overview" className="border-b border-background-200 bg-background-50">
      <div className="mx-auto grid w-full max-w-[1280px] items-center gap-10 px-4 pb-14 pt-10 md:px-6 md:pb-20 md:pt-16 lg:grid-cols-2 lg:gap-14">
        <div className="flex flex-col">
          <span className="inline-flex w-fit items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-1.5 text-xs font-label text-foreground-700">
            <i className="ri-award-line text-accent-600"></i>
            韩国伦理电影在线观看 · 编辑推荐片单
          </span>

          <h1 className="mt-5 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl">
            韩国伦理电影在线观看
            <span className="mt-2 block text-2xl text-foreground-700 md:text-3xl">
              推荐片单、排行榜与高分合集
            </span>
          </h1>

          <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            这里把最新热门与经典高分整理成一份可以慢慢逛的片单：按主题分门别类，用评分和口碑标注方向，也能按关键词快速搜索。看完这一页，你大概就能锁定下一部想看的作品。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <a
              href="#ranking"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-label font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-trophy-line"></i>
              查看完整排行榜
            </a>
            <a
              href="#themes"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-label font-medium text-foreground-800 transition-colors hover:bg-background-100"
            >
              <i className="ri-grid-line"></i>
              按主题挑片
            </a>
          </div>

          <dl className="mt-9 grid max-w-md grid-cols-3 gap-4 border-t border-background-200 pt-6">
            {stats.map((item) => (
              <div key={item.label}>
                <dt className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                  {item.value}
                </dt>
                <dd className="mt-1 text-xs font-label text-foreground-500">
                  {item.label}
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="relative">
          <div className="relative h-[380px] w-full overflow-hidden rounded-lg border border-background-200 md:h-[520px]">
            <img
              src="https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20rain-soaked%20Seoul%20alley%20at%20night%20with%20warm%20amber%20streetlight%20glow%20reflecting%20on%20wet%20asphalt%2C%20a%20lone%20silhouetted%20figure%20walking%20into%20the%20distance%2C%20drifting%20fog%2C%20deep%20golden%20and%20warm%20brown%20color%20grading%2C%20soft%20film%20grain%2C%20quiet%20dramatic%20tension%2C%20moody%20editorial%20cinematography&width=900&height=1120&seq=hero-seoul-night&orientation=portrait"
              alt="雨夜中昏黄灯光下的首尔街巷，营造出韩影的叙事氛围"
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent"></div>
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
              <p className="font-heading text-lg font-bold text-background-50">
                本周编辑推荐
              </p>
              <p className="mt-1 text-sm text-background-100/90">
                《分手的决心》— 当真相看不清，感情反而更清晰。
              </p>
            </div>
          </div>

          <div className="absolute -left-3 top-6 hidden w-40 rounded-lg border border-background-200 bg-background-50 p-3 md:block">
            <p className="text-[11px] font-label text-foreground-500">上榜作品</p>
            <p className="mt-1 font-heading text-2xl font-black text-accent-600">
              9.3
            </p>
            <p className="mt-0.5 text-[11px] font-label text-foreground-600">
              最高编辑评分《寄生虫》
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}